/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 14/2/2022
 */




import NormalFormManager from "./NormalFormManager.js";
import {LogicalSymbols} from "@/core/js/backend/filters/LogicalSymbols.js";


export const FilterOperation = Object.freeze({
	EQUAL: "==",
	LESS: "<",
	GREATER: ">",
	ARRAY_CONTAINS: "array-contains",
	ARRAY_CONTAINS_ANY: "array-contains-any",

	ARRAY_CONTAINS_ALL_CUSTOM: "array-contains-all", //WARNING: This is a custom operation that is not supported by Firestore
	OBJECT_CONTAINS_ANY_CUSTOM: "object-contains-any", //WARNING 1 and 2. 1:This is a custom operation that is not supported by Firestore. 2: Disjunctive form scales very quickly with this.
	OBJECT_CONTAINS_ALL_CUSTOM: "object-contains-all", //WARNING: This is a custom operation that is not supported by Firestore
})

export default class FilterOptions {


	constructor(field, operation, value) {
		this.filterOptions = []
		this.normalFormManager = new NormalFormManager()

		// console.warn("Using custom FilterOptions")
		if(field, operation, value){
			this.add(field, operation, value)
		}
	}

	merge(otherFilterOptions){
		otherFilterOptions.filterOptions.forEach(option => {
			this.add(option.field, option.operation, option.value)
		})
		return this
	}

	reset(){
		this.filterOptions = []
		return this;
	}

	add(field, operation, value){
		this.filterOptions.push({field: field, operation: operation, value: value})
		return this
	}
	addArray(field, value){
		let operation
		if(Array.isArray(value)){
			operation = FilterOperation.ARRAY_CONTAINS_ANY
		} else {
			operation = FilterOperation.ARRAY_CONTAINS
		}
		this.add(field, operation, value)
		return this
	}

	apply(ref){
		// we need to expandFilterOptions before and after DNF conversion because DNF conversion can combine filterOptions that would require further expansion
		let filterOptions = this.expandFilterOptions(this.filterOptions)
		console.log("filterOptions = ", filterOptions)
		filterOptions = this.getFilterOptionsDNF(filterOptions)
		filterOptions = this.expandFilterOptions(filterOptions)

		// let filterOptionsDNF = this.filterOptions

		console.log("filterOptionsDNF = ", filterOptions)
		filterOptions.forEach(option => {
			console.log("filterOptionsDNF2: ref = ", ref, ", option = ", option)
			if(option.field){
				ref = ref.where(option.field, option.operation, option.value)
			} else {
				ref = this.invokeFnBySymbol(option, ref)
			}
		})
		console.log("filterOptionsDNF: ref = ", ref)

		return ref;
	}

	expandFilterOptions(filterOptions){
		let filterItem = new FilterOptions()

		filterOptions.forEach(option => {
			if(option.field){
				if(option.operation === FilterOperation.OBJECT_CONTAINS_ANY_CUSTOM){
					this.performObjectContainsAny(filterItem, option)
				} else if(option.operation === FilterOperation.OBJECT_CONTAINS_ALL_CUSTOM){
					this.performObjectContainsAll(filterItem, option)
				} else if(option.operation === FilterOperation.ARRAY_CONTAINS_ALL_CUSTOM){
					this.performArrayContainsAllCustom(filterItem, option)
				} else if(option.operation === FilterOperation.ARRAY_CONTAINS_ANY){
					this.performArrayContainsAny(filterItem, option)
				} else {
					filterItem.add(option.field, option.operation, option.value)
				}
			} else {
				filterItem.filterOptions.push(option)
			}
		})
		return filterItem.filterOptions
	}

	performObjectContainsAny(filterOptions, option){
		let propsArray = option.value
		let hasData = propsArray.length > 0

		if(hasData){
			filterOptions = filterOptions.orStart()
			propsArray.forEach(prop => {
				let field = `${option.field}.${prop}`
				filterOptions.add(field, FilterOperation.EQUAL, true)
			})
			filterOptions = filterOptions.orEnd()
		}
		return filterOptions
	}

	performArrayContainsAny(filterOptions, option){
		let propsArray = option.value
		let hasData = propsArray.length > 0

		if(hasData){
			filterOptions = filterOptions.orStart()
			propsArray.forEach(prop => {
				filterOptions.add(option.field, FilterOperation.ARRAY_CONTAINS, prop)
			})
			filterOptions = filterOptions.orEnd()
		}
		return filterOptions
	}



	performObjectContainsAll(filterOptions, option){
		let propsArray = option.value
		let hasData = propsArray.length > 0


		if(hasData){
			filterOptions = filterOptions.andStart()
			propsArray.forEach(prop => {
				let field = `${option.field}.${prop}`
				filterOptions.add(field, FilterOperation.EQUAL, true)
			})
			filterOptions = filterOptions.andEnd()
		}
		return filterOptions
	}

	performArrayContainsAllCustom(filterOptions, option){
		let valuesArray = option.value
		let hasData = valuesArray.length > 0

		if(hasData){
			let value = valuesArray.sort().join("_")
			filterOptions.add(option.field, FilterOperation.ARRAY_CONTAINS, value)
		}
		return filterOptions
	}

	isEmpty(){
		return this.filterOptions.length === 0
	}


	getFilterOptionsDNF(filterOptions){
		//convert to Disjunctive Normal Form
		let filterOptionsDNF = this.normalFormManager.convertToDNF(filterOptions, this.mergeOperationsOnSameFields.bind(this))

		return filterOptionsDNF
	}

	mergeOperationsOnSameFields(conjunctionArray){
		let mergableOperations = [FilterOperation.ARRAY_CONTAINS]
		for(let i = 0; i < conjunctionArray.length; i++){
			let option1 = conjunctionArray[i]
			if(mergableOperations.includes(option1.operation)){
				for(let j = i + 1; j < conjunctionArray.length; j++){
					let option2 = conjunctionArray[j]
					if(option2.field === option1.field){
						//if option2 is array-contains-any or array-contains, merge values and set it to option1 (initially option1.value can be an array or single item)
						if(mergableOperations.includes(option2.operation)){

							option1.value = Array.isArray(option1.value) ? option1.value : [option1.value]
							let value2 = Array.isArray(option2.value) ? option2.value : [option2.value]

							option1.operation = FilterOperation.ARRAY_CONTAINS_ALL_CUSTOM
							option1.value = option1.value.concat(value2)

							conjunctionArray.splice(j, 1)
							j--
						}
					}
				}
			}
		}

		return conjunctionArray
	}

	orStart(){
		this.filterOptions.push(LogicalSymbols.OR_START)
		return this
	}
	andStart(){
		this.filterOptions.push(LogicalSymbols.AND_START)
		return this
	}
	orEnd(){
		this.filterOptions.push(LogicalSymbols.OR_END)
		return this
	}
	andEnd(){
		this.filterOptions.push(LogicalSymbols.AND_END)
		return this
	}

	invokeFnBySymbol(symbol, ref){
		switch (symbol){
			case LogicalSymbols.OR_START:
				return ref.orStart()
			case LogicalSymbols.AND_START:
				return ref.andStart()
			case LogicalSymbols.OR_END:
				return ref.orEnd()
			case LogicalSymbols.AND_END:
				return ref.andEnd()
			default:
				console.warn("FilterOptions.invokeFnBySymbol: unknown symbol = ", symbol)
				return ref
		}
	}

}



